export default {
  brand: {
    fileShare: 'Обмен Файлами'
  },
  common: {
    loading: 'Загрузка...',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    download: 'Скачать',
    downloadAll: 'Скачать все',
    downloadSelected: 'Скачать выбранные',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять выделение',
    rootDirectory: 'Корневой каталог',
    createTime: 'Создано',
    expireTime: 'Истекает',
    totalSize: 'Общий размер',
    noFiles: 'Нет файлов'
  },
  share: {
    expired: 'Срок действия общих файлов истек',
    invalidLink: 'Недействительная ссылка для общего доступа',
    needVerifyCode: 'Пожалуйста, введите код извлечения',
    verifyCodeLabel: 'Код',
    verifyCodePlaceholder: 'Введите код извлечения',
    extractFiles: 'Извлечь файлы',
    extractionCodeError: 'Неверный код извлечения',
    uuidRequestFailed: 'Ошибка запроса на скачивание',
    selectFilesFirst: 'Пожалуйста, сначала выберите файлы',
    unknownError: 'Неизвестная ошибка'
  },
  error: {
    networkError: 'Ошибка сети',
    connectionFailed: 'Не удается подключиться к устройству общего доступа. Устройство может быть выключено, в спящем режиме или регион обслуживания мог измениться. Пожалуйста, свяжитесь с владельцем общего доступа.',
    outdatedLink: 'Не удается подключиться к устройству общего доступа. Возможно, использована устаревшая ссылка для общего доступа. Попросите владельца общего доступа обновить систему до v2.0.10 или выше, приложение до v2.1.5 или выше и повторно скопировать ссылку для общего доступа.',
    registryError: 'Ошибка получения настроек публичного сетевого проникновения. Не удается подключиться к службе реестра.',
    missingRegion: 'В ссылке для общего доступа отсутствует информация о регионе обслуживания. Попросите владельца общего доступа обновить систему до v2.0.10 или выше, приложение до v2.1.5 или выше и повторно скопировать ссылку для общего доступа.'
  }
}
